import React from 'react';

const BlockItemPlaceholder = () => (
  <span className="block-item-placeholder">
    Start typing or press <b>/</b> for options
  </span>
);

export default BlockItemPlaceholder;
